import { Controller, useFormContext } from 'react-hook-form'

import { AnchoringRulesFileds } from './AnchoringRulesFileds'

export function AnchoringRulesFiledController({ name }: { name: string }) {
	const { control } = useFormContext()

	return (
		<Controller
			name={`${name}.rules`}
			control={control}
			render={({ field, fieldState: { error } }) => (
				<div className='space-y-2'>
					<AnchoringRulesFileds
						errorSchema={error}
						formData={field.value}
						onChange={field.onChange}
					/>
					{error?.message && (
						<p className='text-sm text-destructive'>{error?.message}</p>
					)}
				</div>
			)}
		/>
	)
}
